import { createStoreConfig } from "./common";
import { Department } from "../dictionaries/organizations";

const endpoints = {
    getItems: { method: "get", url: "/organizations" },
};

export const useOrganizationsDictionaryStore = createStoreConfig<Organization>(endpoints, "organizations_dictionarie", {
    order_by: "name",
    in: "id__in",
    pk: "id",
    ilike: "name__ilike",
    sortOptions: { primarySortField: "name" }
})

export interface Organization {
    id: number;
    description: string;
    tenant: string;
    name: string;
    departments: Department[]
}